import React from 'react'

const Recovery = () => {
  return (
    <div>Recovery</div>
  )
}

export default Recovery